import { React, useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

import "./App.css";

import {
  Layout,
  Card,
  Progress,
  Divider,
  Row,
  Col,
  Typography,
  Popover,
  FloatButton,
} from "antd/lib";

import LoadingSpinner from "./Components/loadingSpinner";
import HeaderComponent from "./Components/HeaderComponent";
import { ReactComponent as ClientLogo } from "./Assets/cm_logo.svg";
import { ReactComponent as CrdClientLogo } from "./Assets/crd_logo.svg";

import { FileTextOutlined } from "@ant-design/icons";

const client =
  window.location.host.startsWith("vw.") ||
  window.location.href.includes("client=vw") ||
  window.location.host.startsWith("pon.") ||
  window.location.href.includes("client=pon")
    ? "vw"
    : "cm";

const { Content } = Layout;
const { Text } = Typography;

// const { Row, Col } = Grid;

function msToTime(duration) {
  var milliseconds = parseInt((duration % 1000) / 100),
    seconds = Math.floor((duration / 1000) % 60),
    minutes = Math.floor((duration / (1000 * 60)) % 60),
    hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

  hours = hours < 10 ? "0" + hours : hours;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  seconds = seconds < 10 ? "0" + seconds : seconds;

  return hours + "h " + minutes + "m " + seconds + "s";
}

const Home = () => {
  // const brands = marketConfig;

  const [popoverVisible, setPopoverVisible] = useState(false);
  const togglePopover = () => {
    setPopoverVisible((prev) => !prev);
  };

  const [marketConfig, setMarketConfig] = useState(null);
  const [collectionsList, setCollectionsList] = useState([]);
  const [dataArr, setData] = useState({});
  const [loading, setLoading] = useState(true);

  var allTests = 0,
    allPassedTests = 0,
    allFailedTests = 0;

  useEffect(() => {
    setLoading(true);
    document.title = `QA Auditor | Home`;
    const fetchData = async () => {
      try {
        const response =
          window.location.host.startsWith("pon.") ||
          window.location.href.includes("client=pon")
            ? await axios.get(
                `https://sdqareports.z6.web.core.windows.net/config/pon/marketConfig.json`,
              )
            : await axios.get(
                `https://sdqareports.z6.web.core.windows.net/config/${client}/marketConfig.json`,
              );

        var responseData = response.data;

        if (
          window.location.host.startsWith("vw.") ||
          window.location.href.includes("client=vw")
        ) {
          responseData["Volkswagen"] = responseData["Volkswagen"].filter(
            (item) => !item.name.match(/nld|NLD/),
          );
        }
        setMarketConfig(responseData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
    setLoading(false);
  }, []);

  useEffect(() => {
    if (marketConfig !== null) {
      setCollectionsList(
        client === "cm"
          ? marketConfig["Nissan Motor Company"]
          : marketConfig["Volkswagen"],
      );

      const fetchDataForAllBrands = async () => {
        try {
          setLoading(true);

          const fetchBrandData = Object.entries(marketConfig).map(
            async ([key, collections]) => {
              const results = await Promise.all(
                collections.map(async (collection) => {
                  const response = await fetch(
                    `https://sdqareports.z6.web.core.windows.net/${collection.name.toLowerCase()}/results_v2.json`,
                    {
                      cache: "no-cache",
                    },
                  );
                  if (response.status === 200) {
                    const jsonResponse = await response.json();
                    var collData = {};
                    collData.collection = collection.name;
                    collData.startTime = jsonResponse.startTime;
                    collData.duration = msToTime(jsonResponse.duration);

                    const distinctCampaigns = new Set();
                    const distinctActions = new Set();
                    var passedCount = 0,
                      failedCount = 0;
                    jsonResponse.results.forEach((result) => {
                      distinctCampaigns.add(result.campaign);
                      distinctActions.add(result.action);
                      if (result.status === "passed") passedCount += 1;
                      if (
                        result.status === "failed" ||
                        result.status === "timedOut"
                      )
                        failedCount += 1;
                    });

                    collData.campaignCount = distinctCampaigns.size;
                    collData.actionCount = distinctActions.size;
                    collData.passedCount = passedCount;
                    collData.failedCount = failedCount;

                    allTests += collData.passedCount + collData.failedCount;
                    allPassedTests += collData.passedCount;
                    allFailedTests += collData.failedCount;

                    return collData;
                  }
                }),
              );
              return [key, results];
            },
          );

          const allData = await Promise.all(fetchBrandData);
          const aggregatedData = Object.fromEntries(allData);
          // console.log("Total tests : ", allTests);
          // console.log("Total passed tests : ", allPassedTests);
          // console.log("Total failed tests : ", allFailedTests);
          setData(aggregatedData);
        } catch (error) {
        } finally {
          setLoading(false);
        }
      };
      fetchDataForAllBrands();
    }
  }, [marketConfig]);

  if (loading) return <LoadingSpinner></LoadingSpinner>;

  return (
    <div>
      <Layout className="layout">
        <HeaderComponent collectionsList={collectionsList} />
        <Content
          style={{
            overflowY: "auto",
            height: "calc(100vh-64px)",
            //background: client === "vw" ? "#F8F5F2" : "#F7FAF2",
            background: "#F7FAF2",
            marginBottom: "2rem",
          }}
        >
          {Object.entries(dataArr).map(([key, values]) => (
            <div key={key} style={{ padding: "0 4vh" }}>
              <Row
                justify="space-between"
                align="middle"
                style={{ marginTop: "1.8rem" }}
              >
                <Col>
                  <Text
                    strong
                    style={{
                      fontFamily: `${client}Compact`,
                      fontSize: client === "vw" ? "3.167rem" : "4.167rem",
                      lineHeight: "0.75",
                    }}
                  >
                    DAILY RUN - RESULTS OVERVIEW
                  </Text>
                </Col>
                <Col>
                  {client === "cm" && (
                    <ClientLogo
                      style={{
                        marginTop: "12px",
                        height: "2rem",
                      }}
                    />
                  )}
                  {client === "vw" && (
                    <CrdClientLogo
                      style={{
                        marginTop: "12px",
                        height: "2.6rem",
                      }}
                    />
                  )}
                </Col>
              </Row>
              <Row>
                <Col
                // span={12}
                // flex="auto"
                // style={{ textAlign: "start", padding: "0 6vh" }}
                >
                  <Text
                    strong
                    style={{
                      fontFamily: `${client}Bold`,
                      fontSize: "1.667rem",
                    }}
                  >
                    {key}
                  </Text>
                </Col>
              </Row>

              <Row
                gutter={{
                  xs: 8,
                  sm: 16,
                  md: 24,
                  lg: 24,
                }}
              >
                {values.map((item, index) => (
                  <>
                    <Col xs={24} sm={24} md={12} lg={8}>
                      <div
                        style={{
                          padding: "2.5rem 0.2rem 0.2rem 0.2rem",
                        }}
                      >
                        {index === 0 && (
                          <Popover
                            overlayInnerStyle={{
                              fontFamily: `${client}Regular`,
                            }}
                            content={
                              <p>
                                Test results by website.
                                <br />
                                Click to go to detailed test results.
                              </p>
                            }
                            // title="Popover Title"
                            trigger="click"
                            placement="topRight"
                            overlayStyle={{
                              maxWidth: 300,
                            }}
                            overlayClassName="tutorialPopover"
                            open={popoverVisible}
                            onOpenChange={(visible) =>
                              setPopoverVisible(visible)
                            }
                          />
                        )}
                        <Link
                          key={index}
                          to={"/" + item.collection.toLowerCase()}
                        >
                          <Card
                            title={item.collection}
                            className="collectionCard"
                            size="large"
                            styles={{
                              header: {
                                //background:
                                //  client === "vw" ? "#F8F5F2" : "#F7FAF2",
                                background: "#F7FAF2",
                                padding: "0",
                              },
                              body: {
                                background:
                                  client === "vw" ? "#C1E5FFBF" : "#D6E6F8",
                              },
                            }}
                            style={{
                              fontFamily: `${client}Bold`,
                              fontSize: "1.667rem",
                              border: "transparent",
                              borderRadius: "0",
                            }}
                          >
                            <Row gutter={24}>
                              <Col span={12}>
                                <Typography.Title
                                  level={4}
                                  style={{
                                    fontFamily: `${client}Bold`,
                                    fontSize: "1.278rem",
                                    color: "#000000",
                                    margin: "0",
                                  }}
                                >
                                  <b>{item.passedCount + item.failedCount}</b>{" "}
                                  Tests
                                </Typography.Title>
                                <Typography.Title
                                  level={4}
                                  type="success"
                                  style={{
                                    fontFamily: `${client}Bold`,
                                    fontSize: "1.278rem",
                                    color:
                                      client === "vw" ? "#007B55" : "#2045C0",
                                    margin: "0",
                                  }}
                                >
                                  <b>{item.passedCount}</b> Pass
                                </Typography.Title>
                                {item.failedCount === 0 && (
                                  <Typography.Title
                                    level={4}
                                    style={{
                                      margin: "0",
                                    }}
                                  >
                                    <br></br>
                                  </Typography.Title>
                                )}
                                {item.failedCount > 0 && (
                                  <Typography.Title
                                    level={4}
                                    style={{
                                      fontFamily: `${client}Bold`,
                                      fontSize: "1.278rem",
                                      color:
                                        client === "vw" ? "#DC3545" : "#F34510",
                                      margin: "0",
                                    }}
                                    type="danger"
                                  >
                                    <b>{item.failedCount}</b> Fail
                                  </Typography.Title>
                                )}
                                {index === 0 && (
                                  <Popover
                                    overlayInnerStyle={{
                                      fontFamily: `${client}Regular`,
                                    }}
                                    content={
                                      <p>
                                        Blue highlights show successful tests.
                                        <br />
                                        Red highlights show failed tests and
                                        should be investigated.
                                      </p>
                                    }
                                    // title="Popover Title"
                                    trigger="click"
                                    placement="bottomLeft"
                                    open={popoverVisible}
                                    overlayClassName="tutorialPopover"
                                    onOpenChange={(visible) =>
                                      setPopoverVisible(visible)
                                    }
                                  />
                                )}
                                <Typography.Title
                                  level={5}
                                  style={{
                                    fontFamily: `${client}Regular`,
                                    fontSize: "0.889rem",
                                    marginTop: "1.5rem",
                                    marginBottom: "0",
                                  }}
                                >
                                  {item.campaignCount} Campaigns
                                </Typography.Title>
                                <Typography.Title
                                  level={5}
                                  style={{
                                    fontFamily: `${client}Regular`,
                                    fontSize: "0.889rem",
                                    marginTop: "0",
                                  }}
                                >
                                  {item.actionCount} Actions
                                </Typography.Title>
                              </Col>
                              <Col
                                span={12}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-evenly",
                                }}
                              >
                                <Progress
                                  type="circle"
                                  // steps={8}
                                  percent={parseInt(
                                    (item.passedCount /
                                      (item.passedCount + item.failedCount)) *
                                      100,
                                  )}
                                  format={(percent) => (
                                    <span
                                      style={{
                                        fontFamily: `${client}Bold`,
                                        fontSize: "1.278rem",
                                      }}
                                    >
                                      {percent}%
                                    </span>
                                  )}
                                  strokeColor={
                                    client === "vw"
                                      ? "rgb(0, 123, 85)"
                                      : "rgba(32, 69, 192, 0.9)"
                                  }
                                  defaultColor={
                                    client === "vw"
                                      ? "rgb(0, 123, 85)"
                                      : "rgba(32, 69, 192, 0.9)"
                                  }
                                  trailColor="#DC3545"
                                  strokeWidth={24}
                                  size={148}
                                  strokeLinecap=""
                                />
                              </Col>
                            </Row>
                            <div
                              style={{
                                marginTop: "1rem",
                                lineHeight: "0.8rem",
                              }}
                            >
                              <Typography.Text
                                italic
                                style={{
                                  fontFamily: `${client}Slanted`,
                                  fontSize: "0.722rem",
                                }}
                              >
                                Last run:{" "}
                                {new Date(item.startTime)
                                  .toString()
                                  .split("GMT")[0]
                                  .trim()}
                                <br />
                                Run time: {item.duration}
                              </Typography.Text>
                            </div>
                          </Card>
                        </Link>
                      </div>
                    </Col>
                  </>
                ))}
              </Row>
            </div>
          ))}

          <FloatButton
            tooltip="Load Help"
            icon={<FileTextOutlined />}
            description="HELP"
            shape="square"
            className="helpButton"
            onClick={togglePopover}
            style={{
              fontFamily: `${client}Regular`,
              insetInlineEnd: 0,
              top: "80%",
              transform: "translateY(-50%)",
              maxHeight: "48px",
            }}
          />
        </Content>
      </Layout>
    </div>
  );
};
export default Home;
